import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import ModalConfirmLogout from "../../components/ModalConfirmLogout";

const TableGameNew = () => {
  const navigate = useNavigate();
  const [isShowLogout, setIsShowLogout] = useState(false);
  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);

  const userInfo = useMemo(() => {
    try {
      return JSON.parse(localStorage.getItem("user_info") || "null");
    } catch {
      return null;
    }
  }, []);

  const gameImg = localStorage.getItem("title_img") || "/assets/demo-card.png";
  const gameTitle = localStorage.getItem("title_text") || "QUYẾT CHIẾN TIỀN THƯỞNG";
  const winPercent = Number(localStorage.getItem("win_percent") || 54);
  const displayName = userInfo?.userName || userInfo?.username || "Xiaofeng";
  const coins = Number(userInfo?.coins ?? 9999999).toLocaleString("en-US");
  const confidence = 90;

  const createWinLogs = () => {
    const users = [
      "xiaofeng099",
      "velixia88",
      "minhslot79",
      "longvip102",
      "baongoc88",
      "anhkhoa777",
      "jackpotpro",
      "hoangnam09",
      "linhcherry",
      "tuanmaxwin",
      "phatloc68",
      "kennywin99",
    ];
    const games = [
      gameTitle,
      "Quyết chiến tiền thưởng",
      "Wild Bounty Showdown",
      "Kho báu miền Tây",
      "Thợ săn hoang dã",
      "Đấu trường vàng",
      "Mê cung jackpot",
      "Vòng quay may mắn",
    ];
    const moneyValues = [
      1200000,
      2800000,
      3500000,
      4800000,
      6200000,
      7500000,
      9800000,
      12500000,
    ];
    const pick = <T,>(items: T[]) => items[Math.floor(Math.random() * items.length)];
    const randomTime = (index: number) => {
      const now = new Date();
      now.setMinutes(now.getMinutes() - index * Math.floor(Math.random() * 4 + 1));
      now.setSeconds(Math.floor(Math.random() * 60));
      return [now.getHours(), now.getMinutes(), now.getSeconds()]
        .map((value) => String(value).padStart(2, "0"))
        .join(":");
    };

    return Array.from({ length: 7 }, (_, index) => ({
      user: pick(users),
      game: pick(games),
      money: `${pick(moneyValues).toLocaleString("en-US")} VND`,
      time: randomTime(index),
    }));
  };

  const [winLogs, setWinLogs] = useState(createWinLogs);

  useEffect(() => {
    setWinLogs(createWinLogs());

    let timeoutId: ReturnType<typeof setTimeout>;
    const scheduleNextUpdate = () => {
      const nextDelay = (Math.floor(Math.random() * 10) + 1) * 60 * 1000;
      timeoutId = setTimeout(() => {
        setWinLogs(createWinLogs());
        scheduleNextUpdate();
      }, nextDelay);
    };

    scheduleNextUpdate();
    return () => clearTimeout(timeoutId);
  }, [gameTitle]);

  return (
    <div className="analysis-page">
      <style>
        {`
          .analysis-page {
            position: relative;
            min-height: 100vh;
            width: 100%;
            overflow-x: hidden;
            color: #fff;
            font-family: "Roboto", Arial, sans-serif;
          }

          .analysis-bg {
            position: fixed;
            inset: 0;
            width: 100%;
            height: 100%;
            object-fit: cover;
            z-index: -1;
          }

          .analysis-topbar {
            position: relative;
            z-index: 2;
            display: flex;
            align-items: flex-start;
            justify-content: space-between;
            padding: 22px 34px 0;
          }

          .analysis-brand {
            width: 255px;
            max-width: 34vw;
            object-fit: contain;
            filter: drop-shadow(0 0 10px rgba(0, 238, 255, 0.35));
          }

          .analysis-user-panel {
            width: 300px;
            max-width: 34vw;
          }

          .analysis-user-row {
            display: flex;
            align-items: center;
            gap: 10px;
          }

          .analysis-pill {
            height: 38px;
            border-radius: 9px;
            border: 1px solid rgba(0, 238, 255, 0.35);
            background: rgba(1, 16, 52, 0.72);
            box-shadow: 0 0 16px rgba(0, 119, 255, 0.35), inset 0 0 18px rgba(0, 119, 255, 0.18);
            display: flex;
            align-items: center;
            color: #fff;
            font-weight: 900;
          }

          .analysis-user-pill {
            flex: 1;
            min-width: 0;
            padding: 0 10px;
            gap: 8px;
            cursor: pointer;
            user-select: none;
          }

          .analysis-coin-pill {
            min-width: 132px;
            padding: 0 12px;
            gap: 8px;
            color: #ffd747;
          }

          .analysis-vip {
            margin-left: auto;
            padding: 3px 8px;
            border-radius: 5px;
            background: linear-gradient(180deg, #ff5a47, #a90e18);
            color: #fff;
            font-size: 10px;
            line-height: 1;
          }

          .analysis-menu {
            margin-top: 8px;
            margin-left: 2px;
            width: 142px;
            padding: 8px 12px;
            border-radius: 8px;
            border: 1px solid rgba(0, 238, 255, 0.34);
            background: rgba(1, 16, 52, 0.68);
            box-shadow: 0 0 16px rgba(0, 119, 255, 0.25);
            text-align: center;
            font-weight: 700;
            color: #ffff00;
            cursor: pointer;
          }

          .analysis-main {
            position: relative;
            z-index: 1;
            width: min(700px, calc(100vw - 40px));
            margin: 18px auto 0;
          }

          .analysis-title-wrap {
            text-align: center;
          }

          .analysis-title-badge {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            min-width: 325px;
            padding: 14px 30px 16px;
            border-radius: 999px;
            background: linear-gradient(180deg, rgba(14, 74, 177, 0.74), rgba(23, 5, 105, 0.7));
            border: 1px solid rgba(0, 238, 255, 0.28);
            box-shadow: 0 0 22px rgba(0, 119, 255, 0.6), inset 0 0 20px rgba(0, 238, 255, 0.18);
            overflow: visible;
          }

          .analysis-title {
            font-size: 36px;
            font-weight: 900;
            line-height: 1.22;
            letter-spacing: 0.02em;
            background: linear-gradient(90deg, #00fbff 0%, #ff00ff 100%);
            -webkit-background-clip: text;
            background-clip: text;
            color: transparent;
            -webkit-text-fill-color: transparent;
            filter: drop-shadow(0 0 16px rgba(0, 238, 255, 0.7));
            display: inline-block;
            padding-top: 0.08em;
          }

          .analysis-result-row {
            position: relative;
            margin-top: 18px;
            display: flex;
            align-items: flex-start;
            gap: 14px;
          }

          .analysis-back {
            position: absolute;
            left: -122px;
            top: 6px;
            display: inline-flex;
            align-items: center;
            gap: 7px;
            border: 1px solid rgba(0, 238, 255, 0.38);
            border-radius: 999px;
            padding: 5px 14px 6px 8px;
            background: rgba(3, 34, 90, 0.75);
            color: #fff;
            font-weight: 800;
            font-size: 16px;
            text-decoration: none;
            box-shadow: 0 0 14px rgba(0, 119, 255, 0.42);
          }

          .analysis-back-dot {
            width: 22px;
            height: 22px;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            border-radius: 50%;
            background: linear-gradient(180deg, #1685ff, #0649a5);
            box-shadow: inset 0 0 7px rgba(255, 255, 255, 0.24);
            font-size: 18px;
          }

          .analysis-game-image {
            width: 235px;
            height: 235px;
            object-fit: cover;
            border-radius: 12px;
            border: 2px solid rgba(0, 238, 255, 0.7);
            box-shadow: 0 0 18px rgba(0, 238, 255, 0.35);
          }

          .analysis-card {
            flex: 1;
            min-height: 235px;
            border-radius: 12px;
            border: 1px solid rgba(0, 238, 255, 0.42);
            background: rgba(0, 10, 44, 0.62);
            box-shadow:
              0 0 18px rgba(0, 119, 255, 0.38),
              inset 0 0 24px rgba(0, 119, 255, 0.16);
            padding: 14px 16px;
          }

          .analysis-card-head {
            display: flex;
            align-items: flex-start;
            gap: 8px;
            justify-content: space-between;
          }

          .analysis-game-title {
            color: #00fbff;
            font-size: 20px;
            font-weight: 900;
            line-height: 1.1;
            text-transform: uppercase;
            text-shadow: 0 0 10px rgba(0, 251, 255, 0.55);
          }

          .analysis-hall-tag {
            flex-shrink: 0;
            border-radius: 999px;
            border: 1px solid rgba(0, 238, 255, 0.55);
            padding: 3px 8px;
            color: #9ffbff;
            font-size: 9px;
            font-weight: 900;
            background: rgba(0, 119, 255, 0.18);
          }

          .analysis-label {
            margin-top: 6px;
            font-size: 14px;
            color: #ffffff;
            font-weight: 700;
            letter-spacing: 0.04em;
          }

          .analysis-score-row {
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 16px;
            margin-top: 2px;
          }

          .analysis-percent {
            font-size: 82px;
            font-weight: 900;
            line-height: 1;
            background: linear-gradient(180deg, #00fbff 0%, #ff00ff 100%);
            -webkit-background-clip: text;
            background-clip: text;
            color: transparent;
            -webkit-text-fill-color: transparent;
            filter: drop-shadow(0 0 15px rgba(0, 251, 255, 0.5));
          }

          .analysis-confidence {
            width: 116px;
            height: 116px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            background:
              radial-gradient(circle at center, rgba(5, 14, 48, 0.95) 0 55%, transparent 56%),
              conic-gradient(#00fbff 0deg, #844bff 235deg, rgba(0, 57, 125, 0.7) 235deg 360deg);
            box-shadow: 0 0 18px rgba(0, 119, 255, 0.45);
          }

          .analysis-confidence-inner {
            width: 88px;
            height: 88px;
            border-radius: 50%;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            background: rgba(3, 12, 43, 0.96);
            box-shadow: inset 0 0 14px rgba(0, 119, 255, 0.35);
          }

          .analysis-confidence-label {
            font-size: 12px;
            font-weight: 900;
            color: #ffffff;
          }

          .analysis-confidence-value {
            font-size: 27px;
            font-weight: 900;
            color: #ffffff;
            line-height: 1.05;
          }

          .analysis-delta {
            margin-top: 4px;
            border-radius: 6px;
            padding: 4px 8px;
            color: #5cff91;
            background: rgba(26, 255, 117, 0.08);
            border: 1px solid rgba(26, 255, 117, 0.22);
            font-size: 12px;
            font-weight: 800;
          }

          .analysis-status-row {
            margin-top: 10px;
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 10px;
          }

          .analysis-status {
            min-height: 52px;
            border-radius: 8px;
            border: 1px solid rgba(0, 238, 255, 0.28);
            background: rgba(1, 16, 52, 0.72);
            display: flex;
            align-items: center;
            gap: 10px;
            padding: 8px 10px;
            box-shadow: inset 0 0 16px rgba(0, 119, 255, 0.12);
          }

          .analysis-status-icon {
            width: 34px;
            height: 34px;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            font-size: 26px;
          }

          .analysis-status-text {
            font-size: 13px;
            font-weight: 800;
            line-height: 1.15;
            color: #ffffff;
          }

          .analysis-status-good {
            display: block;
            color: #39ff88;
            font-size: 17px;
            font-weight: 900;
          }

          .analysis-log {
            margin-top: 22px;
            border-radius: 10px;
            border: 1px solid rgba(0, 238, 255, 0.35);
            background: rgba(0, 8, 35, 0.64);
            box-shadow: 0 0 18px rgba(0, 119, 255, 0.25), inset 0 0 18px rgba(0, 119, 255, 0.13);
            overflow: hidden;
          }

          .analysis-log-head {
            height: 32px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0 14px;
            border-bottom: 1px solid rgba(0, 238, 255, 0.24);
            color: #00fbff;
            font-size: 12px;
            font-weight: 900;
          }

          .analysis-log-btn {
            border: 1px solid rgba(0, 238, 255, 0.35);
            border-radius: 999px;
            padding: 2px 8px;
            font-size: 8px;
            color: #9ffbff;
          }

          .analysis-table {
            width: 100%;
            border-collapse: collapse;
            font-size: 12px;
          }

          .analysis-table th,
          .analysis-table td {
            padding: 5px 12px;
            text-align: center;
            white-space: nowrap;
          }

          .analysis-table th {
            color: #39ff88;
            font-weight: 900;
          }

          .analysis-table td {
            color: #00c8ff;
            font-weight: 700;
          }

          .analysis-table .money {
            color: #ffff00;
          }

          .analysis-table .user {
            color: #ffff00;
          }

          @media (max-width: 768px) {
            .analysis-topbar {
              padding: 14px 14px 0;
              flex-direction: column;
              align-items: center;
              gap: 12px;
            }

            .analysis-brand {
              width: 210px;
              max-width: 82vw;
            }

            .analysis-user-panel {
              width: min(340px, calc(100vw - 28px));
              max-width: none;
            }

            .analysis-user-row {
              flex-direction: row;
              align-items: center;
              gap: 8px;
            }

            .analysis-pill {
              height: 36px;
              font-size: 12px;
            }

            .analysis-user-pill {
              flex: 1 1 auto;
            }

            .analysis-coin-pill {
              min-width: 126px;
              flex: 0 0 auto;
            }

            .analysis-menu {
              margin: 8px auto 0;
            }

            .analysis-main {
              width: min(100% - 28px, 430px);
              margin-top: 24px;
              padding-bottom: 44px;
            }

            .analysis-title-badge {
              min-width: 0;
              width: 100%;
              padding: 12px 16px 14px;
            }

            .analysis-title {
              font-size: 26px;
            }

            .analysis-result-row {
              flex-direction: column;
              align-items: center;
            }

            .analysis-back {
              position: relative;
              left: auto;
              top: auto;
              align-self: flex-start;
              margin-bottom: 10px;
            }

            .analysis-game-image {
              width: min(235px, 80vw);
              height: min(235px, 80vw);
            }

            .analysis-card {
              width: 100%;
              padding: 14px;
              box-sizing: border-box;
            }

            .analysis-card-head {
              align-items: center;
            }

            .analysis-game-title {
              font-size: 17px;
            }

            .analysis-score-row {
              align-items: center;
              gap: 10px;
            }

            .analysis-percent {
              font-size: 56px;
            }

            .analysis-confidence {
              width: 92px;
              height: 92px;
            }

            .analysis-confidence-inner {
              width: 72px;
              height: 72px;
            }

            .analysis-confidence-label {
              font-size: 10px;
            }

            .analysis-confidence-value {
              font-size: 23px;
            }

            .analysis-status-row {
              grid-template-columns: 1fr;
            }

            .analysis-log {
              overflow-x: hidden;
            }

            .analysis-table {
              table-layout: fixed;
              min-width: 0;
              width: 100%;
              font-size: 10px;
            }

            .analysis-table th,
            .analysis-table td {
              padding: 5px 4px;
              white-space: normal;
              overflow-wrap: anywhere;
              word-break: break-word;
              line-height: 1.15;
            }

            .analysis-table th:nth-child(1),
            .analysis-table td:nth-child(1) {
              width: 22%;
            }

            .analysis-table th:nth-child(2),
            .analysis-table td:nth-child(2) {
              width: 30%;
            }

            .analysis-table th:nth-child(3),
            .analysis-table td:nth-child(3) {
              width: 30%;
            }

            .analysis-table th:nth-child(4),
            .analysis-table td:nth-child(4) {
              width: 18%;
            }
          }

          @media (max-width: 430px) {
            .analysis-user-panel {
              width: calc(100vw - 24px);
            }

            .analysis-pill {
              height: 34px;
              font-size: 11px;
            }

            .analysis-coin-pill {
              min-width: 116px;
            }

            .analysis-title {
              font-size: 23px;
            }

            .analysis-game-image {
              width: min(220px, 78vw);
              height: min(220px, 78vw);
            }

            .analysis-percent {
              font-size: 50px;
            }

            .analysis-log-head {
              padding: 0 10px;
            }

            .analysis-table {
              font-size: 9px;
            }

            .analysis-table th,
            .analysis-table td {
              padding: 5px 3px;
            }
          }
        `}
      </style>

      <video className="analysis-bg" autoPlay loop muted playsInline>
        <source
          src={typeof window !== "undefined" && window.innerWidth <= 430 ? "/assets/bg-mb.mp4" : "/assets/bg-pc.mp4"}
          type="video/mp4"
        />
      </video>

      <div className="analysis-topbar">
        <img className="analysis-brand" src="/assets/logo-header.png" alt="Velixia Slot" />

        <div className="analysis-user-panel">
          <div className="analysis-user-row">
            <div
              className="analysis-pill analysis-user-pill"
              role="button"
              tabIndex={0}
              onClick={() => setIsUserMenuOpen((prev) => !prev)}
              onKeyDown={(event) => {
                if (event.key === "Enter" || event.key === " ") {
                  event.preventDefault();
                  setIsUserMenuOpen((prev) => !prev);
                }
              }}
            >
              <img src="/assets/icon-user.png" alt="" style={{ width: 26, height: 26 }} />
              <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{displayName}</span>
              <span className="analysis-vip">VIP 10</span>
            </div>
            <div className="analysis-pill analysis-coin-pill">
              <span
                style={{
                  width: 24,
                  height: 24,
                  borderRadius: "50%",
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  background: "linear-gradient(180deg, #ffd64b, #d28b00)",
                  color: "#8a4b00",
                  fontWeight: 900,
                }}
              >
                $
              </span>
              <span>{coins}</span>
            </div>
          </div>

          {isUserMenuOpen && (
            <div className="analysis-menu" onClick={() => setIsShowLogout(true)}>
              Đăng xuất
            </div>
          )}
        </div>
      </div>

      <main className="analysis-main">
        <div className="analysis-title-wrap">
          <div className="analysis-title-badge">
            <span className="analysis-title">KẾT QUẢ PHÂN TÍCH</span>
          </div>
        </div>

        <section className="analysis-result-row">
          <button className="analysis-back" type="button" onClick={() => navigate(-1)}>
            <span className="analysis-back-dot">‹</span>
            <span>Quay lại</span>
          </button>

          <img
            className="analysis-game-image"
            src={gameImg}
            alt={gameTitle}
            onError={(event) => (event.currentTarget.src = "/assets/demo-card.png")}
          />

          <div className="analysis-card">
            <div className="analysis-card-head">
              <div className="analysis-game-title">{gameTitle}</div>
              <div className="analysis-hall-tag">PG SLOT</div>
            </div>
            <div className="analysis-label">TỶ LỆ THẮNG DỰ KIẾN</div>

            <div className="analysis-score-row">
              <div>
                <div className="analysis-percent">{winPercent}%</div>
                <div className="analysis-delta">↑ 12% so với lần phân tích trước</div>
              </div>

              <div className="analysis-confidence">
                <div className="analysis-confidence-inner">
                  <div className="analysis-confidence-label">ĐỘ TIN CẬY</div>
                  <div className="analysis-confidence-value">{confidence}%</div>
                </div>
              </div>
            </div>

            <div className="analysis-status-row">
              <div className="analysis-status">
                <span className="analysis-status-icon">🛡</span>
                <div className="analysis-status-text">
                  Mức độ rủi ro
                  <span className="analysis-status-good">THẤP</span>
                </div>
              </div>
              <div className="analysis-status">
                <span className="analysis-status-icon">📈</span>
                <div className="analysis-status-text">
                  XU HƯỚNG
                  <span className="analysis-status-good">TÍCH CỰC</span>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="analysis-log">
          <div className="analysis-log-head">
            <span>WIN LOG</span>
            <span className="analysis-log-btn">XEM TẤT CẢ</span>
          </div>
          <table className="analysis-table">
            <thead>
              <tr>
                <th>User</th>
                <th>Game</th>
                <th>Winning money</th>
                <th>Time</th>
              </tr>
            </thead>
            <tbody>
              {winLogs.map((item, index) => (
                <tr key={`${item.user}-${index}`}>
                  <td className="user">{item.user}</td>
                  <td>{item.game}</td>
                  <td className="money">{item.money}</td>
                  <td>{item.time}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </section>
      </main>

      <ModalConfirmLogout
        isShowLogout={isShowLogout}
        setIsShowLogout={() => {
          setIsShowLogout(false);
        }}
      />
    </div>
  );
};

export default TableGameNew;
